import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { TeamsResponse } from '../../pages/teams/types/teams.type';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class TeamsService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  getTeams(): Observable<TeamsResponse> {
    const URL = environment.BASE_URL + 'teams';
    const headers = {
      Authorization:
        'Bearer ' + this.authService.currentUserValue.access_token.token,
    };
    return this.http.get<TeamsResponse>(URL, { headers });
  }
  createTeam(data: any): Observable<any> {
    const URL = environment.BASE_URL + 'teams';
    const headers = {
      Authorization:
        'Bearer ' + this.authService.currentUserValue.access_token.token,
    };
    return this.http.post<any>(URL, data, { headers });
  }
  updatePoints(data: any, id: any): Observable<any> {
    const URL = environment.BASE_URL + 'teams/' + id;
    const headers = {
      Authorization:
        'Bearer ' + this.authService.currentUserValue.access_token.token,
    };
    return this.http.patch<any>(URL, data, { headers });
  }
}
